import { useEffect, useState } from 'react';

// Hook allows to wrap request and return a loading state
// It keeps loading state until all the calls of this async function are finished
export const useLoading = (asyncFn) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingCount, setLoadingCount] = useState(0);

  useEffect(() => {
    setIsLoading(!!loadingCount);
  }, [loadingCount]);

  const controlledRequest = async (...args) => {
    setLoadingCount((prevCount) => prevCount + 1);
    try {
      return await asyncFn(...args);
    } finally {
      setLoadingCount((prevCount) => prevCount - 1);
    }
  };

  return { asyncFn: controlledRequest, isLoading };
};
